import { isMac } from './is-mac';

export const isMetaKey = (event: KeyboardEvent | MouseEvent) => {
  if (isMac()) return !!event.metaKey;
  return !!event.ctrlKey;
};
